/**
 * Post-signup handoff from the homepage demos: persist attribution to the
 * backend (feeds the NUMBERS "Via demo card" column) and pre-mark the
 * roadmap stage estimated in the Sample Journey demo. Runs once from the
 * dashboard after the profile loads.
 */
import { api } from "@/lib/api";
import { toast } from "sonner";

export async function runActivationHandoff({ sid, hasStage, onStage }) {
    let act = null;
    try { act = JSON.parse(window.localStorage.getItem("ml_activation") || "null"); } catch { /* ignore */ }
    if (!act || !act.first_card) return;

    try {
        if (!window.localStorage.getItem("ml_activation_synced")) {
            await api.post("/me/activation-source", {
                first_card: act.first_card,
                last_card: act.last_card || act.first_card,
                completed: act.completed || [],
                signup_card: act.signup_card || null,
            });
            window.localStorage.setItem("ml_activation_synced", "1");
        }
    } catch { /* guest session or older backend — never block the dashboard */ }

    if (act.journey_stage_key && !hasStage) {
        try {
            await api.put(`/profile/${sid}`, { primary_journey_area: act.journey_stage_key });
            if (onStage) onStage(act.journey_stage_key);
            toast("We marked your estimated place on the journey from your homepage assessment.", {
                description: "Open Your Journey anytime to move the marker — no wrong answer.",
                duration: 8000,
            });
            const { journey_stage_key: _used, ...rest } = act;
            window.localStorage.setItem("ml_activation", JSON.stringify(rest));
        } catch { /* ignore */ }
    }
}
